import {
  FilterConfiguration,
  LivingSpaceOption,
  PriceOption,
  PropertySpaceOption,
  RoomCountOption,
  UsageSpaceOption,
} from '@immosky/types';

export class FilterConfigurationBuilder {
  private priceOptions: PriceOption[] = [];
  private livingSpaceOptions: LivingSpaceOption[] = [];
  private propertySpaceOptions: PropertySpaceOption[] = [];
  private usageSpaceOptions: UsageSpaceOption[] = [];
  private roomCountOptions: RoomCountOption[] = [];

  private displaySubcategory = true;
  private displayRoomCount = true;
  private displayLivingSpace = true;
  private displayPropertySpace = true;
  private displayUsageSpace = true;

  setPriceOptions(options: PriceOption[]): this {
    this.priceOptions = options;
    return this;
  }

  setLivingSpaceOptions(options: LivingSpaceOption[]): this {
    this.livingSpaceOptions = options;
    return this;
  }

  setUsageSpaceOptions(options: UsageSpaceOption[]): this {
    this.usageSpaceOptions = options;
    return this;
  }

  setPropertySpaceOptions(options: PropertySpaceOption[]): this {
    this.propertySpaceOptions = options;
    return this;
  }

  setRoomCountOptions(options: RoomCountOption[]): this {
    this.roomCountOptions = options;
    return this;
  }

  setDisplaySubcategory(value: boolean): this {
    this.displaySubcategory = value;
    return this;
  }

  setDisplayRoomCount(value: boolean): this {
    this.displayRoomCount = value;
    return this;
  }

  setDisplayLivingSpace(value: boolean): this {
    this.displayLivingSpace = value;
    return this;
  }

  setDisplayPropertySpace(value: boolean): this {
    this.displayPropertySpace = value;
    return this;
  }

  setDisplayUsageSpace(value: boolean): this {
    this.displayUsageSpace = value;
    return this;
  }

  build(): FilterConfiguration {
    return {
      priceOptions: this.priceOptions,
      livingSpaceOptions: this.livingSpaceOptions,
      propertySpaceOptions: this.propertySpaceOptions,
      usageSpaceOptions: this.usageSpaceOptions,
      roomCountOptions: this.roomCountOptions,
      displaySubcategory: this.displaySubcategory,
      displayRoomCount: this.displayRoomCount,
      displayLivingSpace: this.displayLivingSpace,
      displayPropertySpace: this.displayPropertySpace,
      displayUsageSpace: this.displayUsageSpace,
    };
  }
}
